import axios from 'axios';
import getClosest from './get-closest.js'

const validateFormFields = (() => {

  const handleError = (name, errorList) => {
    const field = document.getElementById(name);

    if (field) {
      const parent = getClosest(field, '.c-form-field');

      parent.classList.add('c-form-error');
      field.setAttribute('aria-describedby', `error-${name}`)

      const error = document.getElementById(`error-${name}`),
            errorMsg = error.innerHTML,
            li = document.createElement('li'),
            a = document.createElement('a');

      a.setAttribute('href', `#${name}`);
      a.innerHTML = errorMsg;

      a.addEventListener('click', (e) => {
        e.preventDefault();
        
        field.focus();
      })

      li.appendChild(a);

      errorList.appendChild(li);
    }
  }
  
  const isValidElement = (element) => {
    return (!['radio', 'submit'].includes(element.type) && element.name !== '__RequestVerificationToken');
  };

  const getRadioValue = (element) => {
   const options = Array.from(element.querySelectorAll('input[type="radio"]')),
         selected = options.find((option) => option.checked == true);

    return selected ? selected.value : '';
  }

  const formatTel = (num) => {
    return num.replace(/\D+/g, "");
  }

  // credit: https://code.lengstorf.com/get-form-values-as-json/
  const formToJSON = (elements) => [].reduce.call(elements, (data, element) => {
    if (isValidElement(element)) {
      if (element.getAttribute('role') == 'radiogroup') {
        data[element.id] = getRadioValue(element);
      } else if (element.type =='checkbox') {
        // for our purposes, a checkbox will only ever be on it's own checked or not checked
        data[element.name] = element.checked;
      } else if (element.type == 'select-one') {
        data[element.name] = element.options[element.selectedIndex].value;
      } else if (element.type == 'tel') {
        data[element.name] = formatTel(element.value);
      } else if (element.name == 'g-recaptcha-response') {
        const res = grecaptcha.getResponse();
        data['GoogleCaptchaUserResponse'] = res;
      } else {
        data[element.name] = element.value;
      }
    }

    return data;
  }, {});

  return {
    init: (formID, api) => {
      const form = document.getElementById(formID),
            data = formToJSON(form.elements),
            fields = Array.from(form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea, select, fieldset[role="radiogroup"], .g-recaptcha')),
            token = form.querySelector('[name="__RequestVerificationToken"]').value,
            globalError = form.querySelector('.c-form-error-list'),
            errorList = globalError.querySelector('ul'),
            captcha = document.querySelector('.g-recaptcha');

      errorList.innerHTML = '';
      globalError.setAttribute('aria-hidden', true);

      fields.forEach((field) => {
        const parent = getClosest(field, '.c-form-field');

        parent.classList.remove('c-form-error');
        field.removeAttribute('aria-describedby');
      })

      return axios.post(api, data,
      {
        headers: {
          'RequestVerificationToken': token
        }
      })
      .then((res) => {
        if(captcha) {
          grecaptcha.reset();
        }
        res.fields = data;
        return res;
      })
      .catch((error) => {
        if(captcha) {
          grecaptcha.reset();
        }
        
        globalError.setAttribute('aria-hidden', false);
        globalError.focus();

        const fieldsWithErrors = []

        Object.keys(error.response.data).forEach(function eachKey(name) { 
          fieldsWithErrors.push(name);
        });

        // Get list of fields with errors to iterate through so that top level error list appears in the same order as the form fields
        fields.filter((field) => {
          return fieldsWithErrors.includes(field.id);
        }).forEach((field) => {
          handleError(field.id, errorList);
        })

        throw error;
      });
    }
  }

})();


export default validateFormFields;



// WEBPACK FOOTER //
// ./src/js/components/form-validation.js